namespace $.$$ {
	export class $shm_hitalama_extension_app extends $.$shm_hitalama_extension_app {

		@ $mol_mem
		maps() {
			return $shm_hitalama_profile.current()?.Maps_list(null)!
		}

		@ $mol_action
		add_map() {
			const entity = this.maps()?.make( [[ null, $giper_baza_rank_deny ]] )
			entity?.title( 'Новая карта' )
			return entity
		}

		@ $mol_mem
		map() {
			return this.maps().remote_list()?.at(0) ?? this.add_map()
		}
		
		login(): string {
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		sub(): readonly ( any )[] {
			if( !this.login() ) return [this.Enter()]
			if( !this.extension_widget_link() ) return [this.No_extension()]
			return this.extension_content()
		}

		extension_auto() {
			const ref = this.extension_widget_link()
			if( !this.extension_widget_link() ) return []
			const widget = this.Map_page().Widget( ref )
			return widget?.auto() ?? []
		}

		extension_widget_link() {
			return this.$.$shm_hitalama_profile.current()?.Extension_current()?.remote()?.link()
		}

		extension_widget_controls() {
			const ref = this.extension_widget_link()
			const widget = this.Map_page().Widget( ref )
			const controls = widget.Sub().controls()
			return controls.length > 0 ? controls : widget.Sub().drag_body()
		}

		extension_content() {
			const ref = this.extension_widget_link()
			const widget = this.Map_page().Widget( ref )
			const controls = widget.Sub().controls()
			return controls.length > 0 ? [widget.Sub().Content_scroll()] : widget.Sub().drag_body() //widget.Sub().Drag_view()
		}
		
	}
}
